import { Typography, Button } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

const OpaqueHomepageButton = styled(Button).attrs((props) => ({
  bg: "rgba(255,255,255,0.4)",
  display: "inline-block",
  fontSize: 14,
  fontWeight: "bold",
  forwardedAs: Link,
  letterSpacing: "tracked",
  mb: 2,
  outline: props.outline,
  textAlign: "center",
  ...props,
}))`
  padding: 8px 40px;
`

const HomepageButton = styled(Button).attrs((props) => ({
  display: "inline-block",
  fontSize: 14,
  fontWeight: "700",
  forwardedAs: Link,
  letterSpacing: "tracked",
  outline: props.outline,
  textAlign: "center",
  to: props.link,
  ...props,
}))`
  padding: 8px 40px;
`

const TitleText = styled(Typography).attrs((props) => ({
  fontSize: { _: "30px", tablet: "38px" },
  letterSpacing: { _: "1px", tablet: "1.3px" },
  ...props,
}))`
  text-transform: uppercase;
`

export { HomepageButton, OpaqueHomepageButton, TitleText }
